<app-sidebar *ngIf="isLogado"> </app-sidebar>
<div class="{{ cssLogado }}">
    <app-navbar *ngIf="isLogado"></app-navbar>
    <div class="content">
        <router-outlet></router-outlet>
    </div>
    <app-footer *ngIf="isLogado"></app-footer>
</div>